import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="mb-4">
              <img 
                src="/gudo-logo-medium.png" 
                alt="GUDO Real Estate" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Tu socio confiable en bienes raíces. Hacemos realidad tus sueños de inversión y hogar.
            </p>
            <div className="flex space-x-3 mt-4">
              <a href="#" className="w-9 h-9 rounded-full bg-gray-800 hover:bg-golden-600 flex items-center justify-center transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-gray-800 hover:bg-golden-600 flex items-center justify-center transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-gray-800 hover:bg-golden-600 flex items-center justify-center transition-colors">
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-golden-600 transition-colors">Inicio</Link>
              </li>
              <li>
                <Link to="/propiedades" className="text-sm hover:text-golden-600 transition-colors">Propiedades</Link>
              </li>
              <li>
                <Link to="/nosotros" className="text-sm hover:text-golden-600 transition-colors">Nosotros</Link>
              </li>
              <li>
                <Link to="/contacto" className="text-sm hover:text-golden-600 transition-colors">Contacto</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Nuestras Propiedades</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/propiedades?type=house" className="text-sm hover:text-golden-600 transition-colors">Casas Residenciales</Link>
              </li>
              <li>
                <Link to="/propiedades?type=apartment" className="text-sm hover:text-golden-600 transition-colors">Apartamentos</Link>
              </li>
              <li>
                <Link to="/propiedades?type=land" className="text-sm hover:text-golden-600 transition-colors">Terrenos</Link>
              </li>
              <li>
                <Link to="/propiedades?type=hotel" className="text-sm hover:text-golden-600 transition-colors">Hoteles</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-golden-600 flex-shrink-0 mt-0.5" />
                <span className="text-sm">Gustavo A. Madero CDMX 07330 México</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-golden-600 flex-shrink-0" />
                <a href="tel:+525649796366" className="text-sm hover:text-golden-600 transition-colors">+52 564 979 6366</a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-golden-600 flex-shrink-0" />
                <a href="mailto:contacto.gudorealstate@gmail.com" className="text-sm hover:text-golden-600 transition-colors">contacto.gudorealstate@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © 2025 GUDO Real Estate. Todos los derechos reservados.
            </p>
            <div className="flex space-x-6">
              <Link to="/privacidad" className="text-sm text-gray-400 hover:text-golden-600 transition-colors">Política de Privacidad</Link>
              <Link to="/terminos" className="text-sm text-gray-400 hover:text-golden-600 transition-colors">Términos y Condiciones</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
